import axios, {AxiosResponse} from "axios";
import {APIS} from "../../../../static/apis";
import {ICompany} from "../../../../companies/companies";

export function getCompanies (): Promise<AxiosResponse<{ data: ICompany[] }>> {
  return axios.get(
    APIS.BASE_AUTH_MS_URL + APIS.GET_COMPANIES
  );
}
